// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Advice from './Advice.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/csmar_theme/index.css'

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.common['device-type'] = 'PC_CSMAR'
// http request 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     if (config.method === 'post' || config.method === 'put') {
//       config.data =
//         config.data instanceof FormData
//           ? config.data
//           : JSON.stringify(config.data)
//       console.log(config.data)
//     }
//     return config
//   },
//   error => {
//     console.error('请求错误信息')
//     // 对请求错误做些什么
//     return Promise.reject(error)
//   }
// )

/* eslint-disable no-new */
new Vue({
  el: '#advice',
  router,
  components: {
    Advice
  },
  template: '<advice/>',
  render: h => h(Advice)
})



// WEBPACK FOOTER //
// ./src/advice.js